import "./style.scss";

import {MESSAGES, TERMS_AND_CONDITIONS, TERMS_VERSION} from "../../constants";
import {useDispatch, useSelector} from "react-redux";
import {Navigate, useNavigate} from "react-router-dom";
import {acceptTermsAndConditions, clearAcceptTerms} from "../../actions/session";
import {route as SWITCH_DISTRICTS_ROUTE} from "../switchDistricts";
import Button from "../../components/common/button";
import Alert from "../../components/common/alert";
import React from "react";

export const route = "/accept-terms";

const AcceptTerms = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const mustAcceptTermsUser = useSelector((state) => state.session.mustAcceptTermsUser);
  const acceptTermsApiSuccess = useSelector((state) => state.session.acceptTermsApiSuccess);
  const acceptTermsApiErrors = useSelector((state) => state.session.acceptTermsApiErrors);

  const acceptTermsClick = async () => {
    await dispatch(acceptTermsAndConditions(mustAcceptTermsUser));
    await navigate(SWITCH_DISTRICTS_ROUTE);
  }

  return (acceptTermsApiSuccess || !mustAcceptTermsUser) ? <Navigate to={"/"}/> : (
    <div className='main-content'>
      {acceptTermsApiErrors && <Alert messageType='error' onDismiss={() => dispatch(clearAcceptTerms())}>{MESSAGES.USERS.acceptTermsError}</Alert>}
      <div className='accept-terms-header'>
        FERPA and Terms of Service Agreement
      </div>
      <div className='accept-terms-container'>
        <div className='terms-body'>
          {TERMS_AND_CONDITIONS}
        </div>
        <div className='terms-version'>
          TES Terms of Service and Privacy Statement - School/District Revised: {TERMS_VERSION}
        </div>
        <div className={'terms-button'}>
          <Button label='Accept' action={acceptTermsClick}/>
        </div>
      </div>
    </div>
  );
}

export default AcceptTerms;